/**
 * resolveAuthTheme — FW-131 KAPSAM A ("acik tema"). Tasarim sozlesmesi
 * (design/current/Auth v2.dc.html satir 362): `var dark = (this.props.tema
 * ?? 'koyu') !== 'acik'` — tema verilmezse KOYU varsayilan kalir. Bu karar,
 * resolveWelcomeBlocks.ts'in ayni gerekcesiyle (bkz. o dosyanin basligi)
 * DOM'a hic dokunmadan test edilebilir, saf bir fonksiyona tasindi.
 *
 * Kullanicinin tema secmesi ya da sistem tercihi (prefers-color-scheme) BU
 * KAPSAMDA DEGIL — tasarim bunu istemiyor (bkz. FW-131 brief "KAPSAM DISI").
 * `tema`, welcomeContent.ts'teki icerik seedinin ayni gerekcesiyle, ileride
 * Console'dan gelecek bir goruntuleme yapilandirmasidir; bugun App.vue'nun
 * prop varsayilaniyla ('koyu') sabittir.
 */

export type AuthThemeName = 'dark' | 'light'

/** tema verilmezse (undefined/null) KOYU doner — tasarimin `?? 'koyu'` kurali. */
export function resolveAuthTheme(theme?: AuthThemeName | null): AuthThemeName {
  return theme === 'light' ? 'light' : 'dark'
}

/**
 * packages/tokens/src/tokens.css `[data-theme="light"]` secicisiyle birebir
 * eslesir. `:root` zaten koyu-once tanimli oldugu icin koyu tarafinda ayrica
 * bir override YOKTUR; yine de deger acikca 'dark' donuyor ki DOM'daki
 * oznitelik testte gozlemlenebilir bir isaret tassin (bir oznitelik hic
 * yazilmamasi, oznitelik adinin kendisinin yanlis yazildigi bir hatayi da
 * "gecti" gosterebilirdi).
 */
export function resolveAuthThemeAttribute(theme?: AuthThemeName | null): 'light' | 'dark' {
  return resolveAuthTheme(theme) === 'light' ? 'light' : 'dark'
}
